var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticStyle:{"font-size":"50px","font-weight":"bold","text-align":"center"}},[_vm._v(" 欢迎使用优达小程序-后台管理系统 ")])])
}]

export { render, staticRenderFns }